import { Link } from 'react-router-dom'

function SliderCittà() {

    return (<>
        <h5 className='mt-5' style={{ textAlign: 'center', fontFamily: 'sans-serif' }}>
            <b>LOCALITA' DA VEDERE</b>
        </h5><br />

        <div style={{ overflow: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden' }}>

            <div className="scrollmenu_article">{/* VENEZIA */}
                <Link to={{ pathname: "/venezia" }} style={{ textDecoration: 'none', color: 'black' }}>
                    <img src={require("../image/claudio-schwarz-VlI9IQgMilw-unsplash.jpg")} width={282} height={230}
                        style={{ border: '2px solid white' }} className='rounded' alt='' />
                    {/* {foto &&
                            <div>
                                <img src={`data:image/jpeg;base64,${foto[0]}`} width={282} height={230}
                                    style={{ border: '2px solid white' }} className='rounded' alt='' />
                            </div>
                        } */}
                    <div style={{ padding: '13px' }}>
                        <h5>Venezia</h5>
                        <p>La Serenissima</p>
                    </div>

                </Link>
            </div>

            <div className="scrollmenu_article">{/* CIVITA BAGNOREGIO */}
                <Link to={{ pathname: "/civita" }} style={{ textDecoration: 'none', color: 'black' }}>
                    <img src={require("../image/gabriele-merlino-unsplash.jpg")} width={282} height={230}
                        style={{ border: '2px solid white' }} className='rounded' alt='' />
                    <div style={{ padding: '13px' }}>
                        <h5>Civita di Bagnoregio</h5>
                        <p>La città che muore</p>
                    </div>
                </Link>
            </div>

            <div className="scrollmenu_article">{/* FIRENZE */}
                <Link to={{ pathname: "/firenze" }} style={{ textDecoration: 'none', color: 'black' }}>
                    <img src={require("../image/alexandra-smielova-unsplash.jpg")} width={282} height={230}
                        style={{ border: '2px solid white' }} className='rounded' alt='' />
                    <div style={{ padding: '13px' }}>
                        <h5>Firenze</h5>
                        <p>La culla del rinascimento</p>
                    </div>
                </Link>
            </div>

            <div className="scrollmenu_article">{/* ROMA */}
                <Link to={{ pathname: "/roma" }} style={{ textDecoration: 'none', color: 'black' }}>
                    <img src={require("../image/caleb-miller-0Bs3et8FYyg-unsplash.jpg")} width={282} height={230}
                        style={{ border: '2px solid white' }} className='rounded' alt='' />
                    <div style={{ padding: '13px' }}>
                        <h5>Roma</h5>
                        <p>La città eterna</p>
                    </div>
                </Link>
            </div>

            <div className="scrollmenu_article">{/* ORVIETO */}
                <Link to={{ pathname: "/orvieto" }} style={{ textDecoration: 'none', color: 'black' }}>
                    <img src={require("../image/mario-la-pergola-AeGitzwf3qw-unsplash.jpg")} width={282} height={230}
                        style={{ border: '2px solid white' }} className='rounded' alt='' />
                    <div style={{ padding: '13px' }}>
                        <h5>Orvieto</h5>
                        <p>...il pozzo di San Patrizio</p>
                    </div>
                </Link>
            </div>

            <div className="scrollmenu_article">{/* MATERA */}
                <Link to={{ pathname: "/matera" }} style={{ textDecoration: 'none', color: 'black' }}>
                    <img src={require("../image/moira-nazzari-BY25ED6PSJk-unsplash.jpg")} width={282} height={230}
                        style={{ border: '2px solid white' }} className='rounded' alt='' />
                    <div style={{ padding: '13px' }}>
                        <h5>Matera</h5>
                        <p>I sassi e le chiese rupestri</p>
                    </div>
                </Link>
            </div>
        </div>
    </>)
}
export default SliderCittà